import React from 'react';
import cn from 'classnames';
// Icons
import AlertIcon from '../../public/images/iconsV3/Alert.svg';
import AlertTriangleIcon from '../../public/images/iconsV3/AlertTriangle.svg';
import ArrowDownIcon from '../../public/images/iconsV3/ArrowDown.svg';
import ArrowLeftIcon from '../../public/images/iconsV3/ArrowLeft.svg';
import ArrowRightIcon from '../../public/images/iconsV3/ArrowRight.svg';
import ArrowUpIcon from '../../public/images/iconsV3/ArrowUp.svg';
import AwardIcon from '../../public/images/iconsV3/Award.svg';
import BagIcon from '../../public/images/iconsV3/Bag.svg';
import CalendarCheckIcon from '../../public/images/iconsV3/CalendarCheck.svg';
import CalendarPlusIcon from '../../public/images/iconsV3/CalendarPlusIcon.svg';
import CalendarDaysIcon from '../../public/images/iconsV3/CalendarDays.svg';
import CalendarIcon from '../../public/images/iconsV3/Calendar.svg';
import CheckAll from '../../public/images/iconsV3/CheckAll.svg';
import CheckCircleIcon from '../../public/images/iconsV3/CheckCircle.svg';
import CheckIcon from '../../public/images/iconsV3/Check.svg';
import ChevronDownIcon from '../../public/images/iconsV3/ChevronDown.svg';
import ChevronLeftIcon from '../../public/images/iconsV3/ChevronLeft.svg';
import ChevronRightIcon from '../../public/images/iconsV3/ChevronRight.svg';
import ChevronUpIcon from '../../public/images/iconsV3/ChevronUp.svg';
import CloseIcon from '../../public/images/iconsV3/Close.svg';
import CogIcon from '../../public/images/iconsV3/Cog.svg';
import DollarIcon from '../../public/images/iconsV3/Dollar.svg';
import DollarSignIcon from '../../public/images/iconsV3/DollarSign.svg';
import CurvedDollarIcon from '../../public/images/iconsV3/CurvedDollar.svg';
import DownloadIcon from '../../public/images/iconsV3/Download.svg';
import FilterIcon from '../../public/images/iconsV3/Filter.svg';
import FilterOffIcon from '../../public/images/iconsV3/FilterOff.svg';
import HomeIcon from '../../public/images/iconsV3/Home.svg';
import HomeOutlineIcon from '../../public/images/iconsV3/HomeOutline.svg';
import ImageIcon from '../../public/images/iconsV3/Image.svg';
import ImageIconV2 from '../../public/images/iconsV3/ImageV2.svg';
import InfoCircleIcon from '../../public/images/iconsV3/InfoCircle.svg';
import InfoCircleOutlineIcon from '../../public/images/iconsV3/InfoCircleOutline.svg';
import MicrophoneIcon from '../../public/images/iconsV3/Microphone.svg';
import MicrophoneOutlineIcon from '../../public/images/iconsV3/MicrophoneOutline.svg';
import MinusCircleIcon from '../../public/images/iconsV3/MinusCircle.svg';
import MoreHorizontal from '../../public/images/iconsV3/MoreHorizontal.svg';
import NotificationBell from '../../public/images/iconsV3/NotificationBell.svg';
import CoinsIcon from '../../public/images/iconsV3/Coins.svg';
import MapPinIcon from '../../public/images/iconsV3/MapPin.svg';
import PencilIcon from '../../public/images/iconsV3/Pencil.svg';
import PercentIcon from '../../public/images/iconsV3/Percent.svg';
import RefreshCwIcon from '../../public/images/iconsV3/RefreshCw.svg';
import PlayIcon from '../../public/images/iconsV3/Play.svg';
import PlaySolidIcon from '../../public/images/iconsV3/PlaySolid.svg';
import PlayTransparentOutlinedIcon from '../../public/images/iconsV3/PlayTransparentOutlined.svg';
import PlusCircleIcon from '../../public/images/iconsV3/PlusCircle.svg';
import PlusCircleOutlineIcon from '../../public/images/iconsV3/PlusCircleOutline.svg';
import PlusIcon from '../../public/images/iconsV3/Plus.svg';
import SearchIcon from '../../public/images/iconsV3/Search.svg';
import Share from '../../public/images/iconsV3/Share.svg';
import StarIcon from '../../public/images/iconsV3/Star.svg';
import StarOutlineIconIcon from '../../public/images/iconsV3/StarOutline.svg';
import TrophyIcon from '../../public/images/iconsV3/Trophy.svg';
import SparklesIcon from '../../public/images/iconsV3/Sparkles.svg';
import StreamIcon from '../../public/images/iconsV3/Stream.svg';
import TagIcon from '../../public/images/iconsV3/Tag.svg';
import TagOutlineIcon from '../../public/images/iconsV3/TagOutline.svg';
import TimerIcon from '../../public/images/iconsV3/Timer.svg';
import TrashIcon from '../../public/images/iconsV3/Trash.svg';
import UploadIcon from '../../public/images/iconsV3/Upload.svg';
import VideoIcon from '../../public/images/iconsV3/Video.svg';
import VideoRecorderIcon from '../../public/images/iconsV3/VideoRecorder.svg';
import UserSquareIcon from '../../public/images/iconsV3/UserSquare.svg';
import HashIcon from '../../public/images/iconsV3/Hash.svg';
import MentionIcon from '../../public/images/iconsV3/Mention.svg';
import VideoPlaylistIcon from '../../public/images/iconsV3/VideoPlaylist.svg';
import EyeIcon from '../../public/images/iconsV3/Eye.svg';
import EyeOffIcon from '../../public/images/iconsV3/EyeOff.svg';
import UserIcon from '../../public/images/iconsV3/User.svg';
import ShoppingCartIcon from '../../public/images/iconsV3/ShoppingCart.svg';
import LogoutIcon from '../../public/images/iconsV3/Logout.svg';
import CircleSmallIcon from '../../public/images/iconsV3/CircleSmall.svg';
import CircleDottedIcon from '../../public/images/iconsV3/CircleDotted.svg';
import GoogleIcon from '../../public/images/iconsV3/Google.svg';
import FacebookIcon from '../../public/images/iconsV3/Facebook.svg';
import XIcon from '../../public/images/iconsV3/X.svg';
import WhatsAppIcon from '../../public/images/iconsV3/WhatsApp.svg';
import ShareArrowIcon from '../../public/images/iconsV3/ShareArrow.svg';
import TikTokIcon from '../../public/images/iconsV3/TikTok.svg';
import YoutubeIcon from '../../public/images/iconsV3/Youtube.svg';
import InstagramIcon from '../../public/images/iconsV3/Instagram.svg';
import InstagramGradientIcon from './components/InstagramGradientIcon';
import DollarSignGoldIcon from './components/DollarSignGoldIcon';
import TikTokColoredIcon from '../../public/images/iconsV3/TikTokColored.svg';
import AtSignIcon from '../../public/images/iconsV3/AtSign.svg';
import MessageSquareIcon from '../../public/images/iconsV3/MessageSquare.svg';
import TikTokGradientIcon from '../../public/images/iconsV3/TikTokGradient.svg';
import ShirtOutlineIcon from '../../public/images/iconsV3/ShirtOutline.svg';
// Merch type icons
import MerchTShirtIcon from '../../public/images/iconsV3/Merch/TShirt.svg';
import MerchHoodieIcon from '../../public/images/iconsV3/Merch/Hoodie.svg';
import MerchJoggersIcon from '../../public/images/iconsV3/Merch/Joggers.svg';
import MerchCompressionShirtIcon from '../../public/images/iconsV3/Merch/CompressionShirt.svg';
import MerchHatIcon from '../../public/images/iconsV3/Merch/Hat.svg';
import MerchPickForMeIcon from '../../public/images/iconsV3/Merch/PickForMe.svg';
import MerchGenerateAgainIcon from '../../public/images/iconsV3/Merch/GenerateAgain.svg';
import MerchCheckCircleIcon from '../../public/images/iconsV3/Merch/CheckCircle.svg';
import MerchXCloseIcon from '../../public/images/iconsV3/Merch/XClose.svg';
import MerchUploadIcon from '../../public/images/iconsV3/Merch/Upload01.svg';
import MerchImageXIcon from '../../public/images/iconsV3/Merch/ImageX.svg';
import MerchOutlineCloseIcon from '../../public/images/iconsV3/Merch/OutlineClose.svg';
import MerchAlertSquareIcon from '../../public/images/iconsV3/Merch/AlertSquare.svg';
import MerchLightbulbIcon from '../../public/images/iconsV3/Merch/Lightbulb.svg';
import MerchDropIcon from '../../public/images/iconsV3/Merch/Drop.svg';
import MerchFiletypePngIcon from '../../public/images/iconsV3/Merch/FiletypePng.svg';
import ShoppingBagIcon from '../../public/images/iconsV3/ShoppingBag.svg';
import RecordIcon from '../../public/images/iconsV3/Record.svg';
import Heart from '../../public/images/icons/heart-icon.svg';
import MailIcon from '../../public/images/iconsV3/MailIcon.svg';
import MinusIcon from '../../public/images/iconsV3/Minus.svg';
import InfoImage from '../../public/images/footer/infoImage.svg';
import PauseSolidIcon from '../../public/images/iconsV3/PauseSolid.svg';
import CopyIcon from '../../public/images/iconsV3/Copy.svg';
import CloudUpload from '../../public/images/iconsV3/CloudUpload.svg';
import SolidAddIcon from '../../public/images/iconsV3/SolidAdd.svg';
import FilterOutline from '../../public/images/iconsV3/FilterOutline.svg';
import Bitcoin from '../../public/images/iconsV3/Bitcoin.svg';
import Weed from '../../public/images/iconsV3/Weed.svg';
import Alcohol from '../../public/images/iconsV3/Alcohol.svg';
import Cigarette from '../../public/images/iconsV3/Cigarette.svg';
import Dice from '../../public/images/iconsV3/Dice.svg';
import Dashboard from '../../public/images/iconsV3/Dashboard.svg';
import CaretUpDown from '../../public/images/icons/CaretUpDown.svg';
import MoreAlternate from '../../public/images/icons/more-alternate.svg';
import DoubleCheck from '../../public/images/iconsV3/DoubleCheck.svg';
import CircleFilled from '../../public/images/icons/circle-filled.svg';
import FaceWithHeadphones from '../../public/images/iconsV3/FaceWithHeadphones.svg';
import LinkIcon from '../../public/images/iconsV3/Link.svg';
import Wallet from '../../public/images/iconsV3/Wallet.svg';
import OctagonAlert from '../../public/images/iconsV3/OctagonAlert.svg';
import DotsVertical from '../../public/images/iconsV3/DotsVertical.svg';
import BotIcon from '../../public/images/iconsV3/Bot.svg';
import ChartBarIcon from '../../public/images/iconsV3/ChartBar.svg';
import UsersGroupIcon from '../../public/images/iconsV3/UsersGroup.svg';
import SwordsIcon from '../../public/images/iconsV3/Swords.svg';
import ChromecastIcon from '../../public/images/iconsV3/Chromecast.svg';
import MegaphoneIcon from '../../public/images/iconsV3/Megaphone.svg';
import AnnouncementIcon from '../../public/images/iconsV3/Announcement.svg';
import InboxIcon from '../../public/images/iconsV3/Inbox.svg';
import ChatBubbleIcon from '../../public/images/iconsV3/ChatBubble.svg';
import MessageChatCircleIcon from '../../public/images/iconsV3/MessageChatCircle.svg';
import UserCircleIcon from '../../public/images/iconsV3/user-circle.svg';
import BioIcon from '../../public/images/iconsV3/bio-icon.svg';
import BrandDealIcon from '../../public/images/iconsV3/brand-deal-icon.svg';
import PersonalVideoIcon from '../../public/images/iconsV3/personal-video-icon.svg';
import CameraIcon from '../../public/images/iconsV3/Camera.svg';
import CameraArrowIcon from '../../public/images/iconsV3/CameraArrow.svg';
import CameraPlusIcon from '../../public/images/iconsV3/CameraPlus.svg';
import CalendarCheckedIcon from '../../public/images/iconsV3/CalendarChecked.svg';
import CalendarSelectIcon from '../../public/images/iconsV3/CalendarSelect.svg';
import StopwatchIcon from '../../public/images/iconsV3/Stopwatch.svg';
import RocketIcon from '../../public/images/iconsV3/Rocket.svg';
import PenOutlineIcon from '../../public/images/iconsV3/PenOutline.svg';
import TipHandIcon from '../../public/images/iconsV3/TipHand.svg';
import CloseCircleIcon from '../../public/images/iconsV3/CloseCircle.svg';
import AnalyticsIcon from '../../public/images/iconsV3/Analytics.svg';
import UserPlusIcon from '../../public/images/iconsV3/UserPlus.svg';
import VideoCameraIcon from '../../public/images/iconsV3/VideoCamera.svg';
import UsersThreeIcon from '../../public/images/iconsV3/UsersThree.svg';
import VerifiedBadgeIcon from '../../public/images/iconsV3/VerifiedBadge.svg';
import VectorArrowIcon from '../../public/images/iconsV3/VectorArrow.svg';
import CrownIcon from '../../public/images/iconsV3/Crown.svg';
import VerifiedIcon from '../../public/images/iconsV3/Verified.svg';
import OutlineQuestionMarkIcon from '../../public/images/iconsV3/OutlineQuestionMark.svg';
import BrandAvatarPlaceholderIcon from '../../public/images/iconsV3/BrandAvatarPlaceholder.svg';
import BookIcon from '../../public/images/iconsV3/Book.svg';
import UserAvatarCircle from '../../public/images/iconsV3/UserAvatarCircle.svg';
import UploadCloud from '../../public/images/iconsV3/UploadCloud.svg';
import TrendingUpIcon from '../../public/images/iconsV3/trade_up_01.svg';
import Amex from '../../public/images/iconsV3/Amex.svg';
import Mastercard from '../../public/images/iconsV3/Maestro.svg';
import Visa from '../../public/images/iconsV3/Visa.svg';
import CreditCardAdd from '../../public/images/iconsV3/CreditCardAdd.svg';
import RequestHelp from '../../public/images/iconsV3/RequestHelp.svg';
import SendIcon from '../../public/images/iconsV3/Send.svg';
import SendFilledIcon from '../../public/images/iconsV3/SendFilled.svg';
import PaperclipIcon from '../../public/images/iconsV3/Paperclip.svg';
import SecondaryLogoIcon from '../../public/images/iconsV3/SecondaryLogo.svg';
import SecondaryMegaphoneIcon from '../../public/images/iconsV3/SecondaryMegaphone.svg';
import ShoppingWalletIcon from '../../public/images/iconsV3/ShoppingWallet.svg';
import PersonalVideoIconV2 from '../../public/images/iconsV3/PersonalVideo.svg';
import OutlineFlagIcon from '../../public/images/iconsV3/OutlineFlag.svg';
import AudienceIcon from '../../public/images/iconsV3/Audience.svg';
import MovieIcon from '../../public/images/iconsV3/Movie.svg';
import FollowersPlusIcon from '../../public/images/iconsV3/FollowersPlus.svg';
import GiftIcon from '../../public/images/iconsV3/Gift.svg';
import ClockIcon from '../../public/images/iconsV3/Clock.svg';
import TopRightArrowSquareIcon from '../../public/images/iconsV3/TopRightArrowSquare.svg';
import MicrophoneLeftIcon from '../../public/images/iconsV3/MicrophoneLeft.svg';
import BuildingIcon from '../../public/images/iconsV3/Building.svg';
import TimelineIcon from '../../public/images/iconsV3/Timeline.svg';
import TicketIcon from '../../public/images/iconsV3/Ticket.svg';
import LockIcon from '../../public/images/iconsV3/Lock.svg';
import ClockStopwatchIcon from '../../public/images/iconsV3/ClockStopwatch.svg';
import MarkerPinIcon from '../../public/images/iconsV3/MarkerPin.svg';
import EditLineIcon from '../../public/images/iconsV3/EditLine.svg';
import CopySquaresIcon from '../../public/images/iconsV3/CopySquares.svg';
import TicketTwoIcon from '../../public/images/iconsV3/TicketTwo.svg';
// Athlete DB claim icons
import ClaimPressInterviewsIcon from '../../public/images/athlete-db-claim/icon-press-interviews.svg';
import ClaimSocialClipsIcon from '../../public/images/athlete-db-claim/icon-social-clips.svg';
import ClaimMerchDropsIcon from '../../public/images/athlete-db-claim/icon-merch-drops.svg';
import ClaimMemorabiliaIcon from '../../public/images/athlete-db-claim/icon-memorabilia.svg';
import ClaimDropExperiencesIcon from '../../public/images/athlete-db-claim/icon-drop-experiences.svg';
import ClaimBrandOpportunitiesIcon from '../../public/images/athlete-db-claim/icon-brand-opportunities.svg';
import ClaimStepProfileIcon from '../../public/images/athlete-db-claim/icon-step-claim-profile.svg';
import ClaimStepContentIcon from '../../public/images/athlete-db-claim/icon-step-create-content.svg';
import ClaimStepEarnIcon from '../../public/images/athlete-db-claim/icon-step-activate-earn.svg';
import ClaimVerifiedBadgeIcon from '../../public/images/athlete-db-claim/icon-verified-badge.svg';
import ClaimDotSeparatorIcon from '../../public/images/athlete-db-claim/icon-dot-separator.svg';
import ClaimViewsEyeIcon from '../../public/images/athlete-db-claim/icon-eye.svg';
import ClaimQuoteIcon from '../../public/images/athlete-db-claim/icon-quote.svg';
import ClaimExternalLinkIcon from '../../public/images/athlete-db-claim/icon-external-link.svg';
// Video controls
import CameraOnOutlineIcon from '../../public/images/iconsV3/VideoControls/CameraOnOutline.svg';
import CameraOffOutlineIcon from '../../public/images/iconsV3/VideoControls/CameraOffOutline.svg';
import MicrophoneOnOutlineIcon from '../../public/images/iconsV3/VideoControls/MicrophoneOnOutline.svg';
import MicrophoneOffOutlineIcon from '../../public/images/iconsV3/VideoControls/MicrophoneOffOutline.svg';
// Menu icons
import Bag from '../../public/images/iconsV3/MenuIcons/Bag.svg';
import Bell from '../../public/images/iconsV3/MenuIcons/Bell.svg';
import Cog from '../../public/images/iconsV3/MenuIcons/Cog.svg';
import Microphone from '../../public/images/iconsV3/MenuIcons/Microphone.svg';
import Play from '../../public/images/iconsV3/MenuIcons/Play.svg';
import PriceTag from '../../public/images/iconsV3/MenuIcons/PriceTag.svg';
import Sales from '../../public/images/iconsV3/MenuIcons/Sales.svg';
import Shirt from '../../public/images/iconsV3/MenuIcons/Shirt.svg';
import ShoppingCart from '../../public/images/iconsV3/MenuIcons/ShoppingCart.svg';
import Star from '../../public/images/iconsV3/MenuIcons/Star.svg';
import Stats from '../../public/images/iconsV3/MenuIcons/Stats.svg';
import Streams from '../../public/images/iconsV3/MenuIcons/Streams.svg';
import UserCircle from '../../public/images/iconsV3/MenuIcons/UserCircle.svg';
// Styles
import styles from './MillionsIcon.module.scss';

const ICONS = {
  alert: AlertIcon,
  alertTriangle: AlertTriangleIcon,
  arrowDown: ArrowDownIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  arrowUp: ArrowUpIcon,
  award: AwardIcon,
  bag: BagIcon,
  calendar: CalendarIcon,
  calendarCheck: CalendarCheckIcon,
  calendarDays: CalendarDaysIcon,
  calendarPlus: CalendarPlusIcon,
  check: CheckIcon,
  checkAll: CheckAll,
  checkCircle: CheckCircleIcon,
  chevronDown: ChevronDownIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  chevronUp: ChevronUpIcon,
  close: CloseIcon,
  cog: CogIcon,
  dollar: DollarIcon,
  dollarSign: DollarSignIcon,
  curvedDollar: CurvedDollarIcon,
  download: DownloadIcon,
  filter: FilterIcon,
  filterOff: FilterOffIcon,
  home: HomeIcon,
  homeOutline: HomeOutlineIcon,
  image: ImageIcon,
  imageV2: ImageIconV2,
  infoCircle: InfoCircleIcon,
  infoCircleOutline: InfoCircleOutlineIcon,
  microphone: MicrophoneIcon,
  microphoneOutline: MicrophoneOutlineIcon,
  minusCircle: MinusCircleIcon,
  moreHorizontal: MoreHorizontal,
  notificationBell: NotificationBell,
  coins: CoinsIcon,
  mapPin: MapPinIcon,
  pencil: PencilIcon,
  percent: PercentIcon,
  refreshCw: RefreshCwIcon,
  play: PlayIcon,
  playSolid: PlaySolidIcon,
  playTransparentOutlined: PlayTransparentOutlinedIcon,
  plus: PlusIcon,
  plusCircle: PlusCircleIcon,
  plusCircleOutline: PlusCircleOutlineIcon,
  search: SearchIcon,
  share: Share,
  shareArrow: ShareArrowIcon,
  star: StarIcon,
  starOutline: StarOutlineIconIcon,
  trophy: TrophyIcon,
  sparkles: SparklesIcon,
  stream: StreamIcon,
  tag: TagIcon,
  tagOutline: TagOutlineIcon,
  timer: TimerIcon,
  trash: TrashIcon,
  crown: CrownIcon,
  upload: UploadIcon,
  video: VideoIcon,
  videoRecorder: VideoRecorderIcon,
  userSquare: UserSquareIcon,
  hash: HashIcon,
  mention: MentionIcon,
  videoPlaylist: VideoPlaylistIcon,
  eye: EyeIcon,
  eyeOff: EyeOffIcon,
  user: UserIcon,
  userAvatarCircle: UserAvatarCircle,
  shoppingCart: ShoppingCartIcon,
  logout: LogoutIcon,
  circleSmall: CircleSmallIcon,
  circleDotted: CircleDottedIcon,
  google: GoogleIcon,
  facebook: FacebookIcon,
  x: XIcon,
  whatsapp: WhatsAppIcon,
  tiktok: TikTokIcon,
  youtube: YoutubeIcon,
  instagram: InstagramIcon,
  instagramGradient: InstagramGradientIcon,
  tiktokColored: TikTokColoredIcon,
  atSign: AtSignIcon,
  messageSquare: MessageSquareIcon,
  tiktokGradient: TikTokGradientIcon,
  shirtOutline: ShirtOutlineIcon,
  merchTShirt: MerchTShirtIcon,
  merchHoodie: MerchHoodieIcon,
  merchJoggers: MerchJoggersIcon,
  merchCompressionShirt: MerchCompressionShirtIcon,
  merchHat: MerchHatIcon,
  merchPickForMe: MerchPickForMeIcon,
  merchGenerateAgain: MerchGenerateAgainIcon,
  merchCheckCircle: MerchCheckCircleIcon,
  merchXClose: MerchXCloseIcon,
  merchUpload: MerchUploadIcon,
  merchImageX: MerchImageXIcon,
  merchOutlineClose: MerchOutlineCloseIcon,
  merchAlertSquare: MerchAlertSquareIcon,
  merchLightbulb: MerchLightbulbIcon,
  merchDrop: MerchDropIcon,
  merchFiletypePng: MerchFiletypePngIcon,
  shoppingBag: ShoppingBagIcon,
  record: RecordIcon,
  heart: Heart,
  mail: MailIcon,
  minus: MinusIcon,
  infoImage: InfoImage,
  pauseSolid: PauseSolidIcon,
  copy: CopyIcon,
  cloudUpload: CloudUpload,
  solidAdd: SolidAddIcon,
  filterOutline: FilterOutline,
  weed: Weed,
  alcohol: Alcohol,
  bitcoin: Bitcoin,
  dice: Dice,
  cigarette: Cigarette,
  v3Dashboard: Dashboard,
  caretUpDown: CaretUpDown,
  moreAlternate: MoreAlternate,
  doubleCheck: DoubleCheck,
  circleFilled: CircleFilled,
  faceWithHeadphones: FaceWithHeadphones,
  link: LinkIcon,
  wallet: Wallet,
  octagonAlert: OctagonAlert,
  dotsVertical: DotsVertical,
  bot: BotIcon,
  chartBar: ChartBarIcon,
  usersGroup: UsersGroupIcon,
  swords: SwordsIcon,
  chromecast: ChromecastIcon,
  megaphone: MegaphoneIcon,
  announcement: AnnouncementIcon,
  inbox: InboxIcon,
  chatBubble: ChatBubbleIcon,
  messageChatCircle: MessageChatCircleIcon,
  personalVideo: PersonalVideoIcon,
  bio: BioIcon,
  brandDeal: BrandDealIcon,
  userCircle: UserCircleIcon,
  camera: CameraIcon,
  cameraArrow: CameraArrowIcon,
  cameraPlus: CameraPlusIcon,
  calendarChecked: CalendarCheckedIcon,
  calendarSelect: CalendarSelectIcon,
  stopwatch: StopwatchIcon,
  rocket: RocketIcon,
  penOutline: PenOutlineIcon,
  tipHand: TipHandIcon,
  closeCircle: CloseCircleIcon,
  analytics: AnalyticsIcon,
  userPlus: UserPlusIcon,
  videoCamera: VideoCameraIcon,
  usersThree: UsersThreeIcon,
  verifiedBadge: VerifiedBadgeIcon,
  vectorArrow: VectorArrowIcon,
  verified: VerifiedIcon,
  outlineQuestionMark: OutlineQuestionMarkIcon,
  brandAvatarPlaceholder: BrandAvatarPlaceholderIcon,
  book: BookIcon,
  uploadCloud: UploadCloud,
  trendingUp: TrendingUpIcon,
  amex: Amex,
  mastercard: Mastercard,
  visa: Visa,
  creditCardAdd: CreditCardAdd,
  requestHelp: RequestHelp,
  send: SendIcon,
  sendFilled: SendFilledIcon,
  paperclip: PaperclipIcon,
  secondaryLogo: SecondaryLogoIcon,
  secondaryMegaphone: SecondaryMegaphoneIcon,
  personalVideoV2: PersonalVideoIconV2,
  shoppingWallet: ShoppingWalletIcon,
  outlineFlag: OutlineFlagIcon,
  audience: AudienceIcon,
  movie: MovieIcon,
  followersPlus: FollowersPlusIcon,
  gift: GiftIcon,
  clock: ClockIcon,
  topRightArrowSquare: TopRightArrowSquareIcon,
  microphoneLeft: MicrophoneLeftIcon,
  building: BuildingIcon,
  timeline: TimelineIcon,
  ticket: TicketIcon,
  lock: LockIcon,
  clockStopwatch: ClockStopwatchIcon,
  markerPin: MarkerPinIcon,
  editLine: EditLineIcon,
  copySquares: CopySquaresIcon,
  ticketTwo: TicketTwoIcon,
  dollarSignGold: DollarSignGoldIcon,
  // Athlete DB claim icons
  claimPressInterviews: ClaimPressInterviewsIcon,
  claimSocialClips: ClaimSocialClipsIcon,
  claimMerchDrops: ClaimMerchDropsIcon,
  claimMemorabilia: ClaimMemorabiliaIcon,
  claimDropExperiences: ClaimDropExperiencesIcon,
  claimBrandOpportunities: ClaimBrandOpportunitiesIcon,
  claimStepProfile: ClaimStepProfileIcon,
  claimStepContent: ClaimStepContentIcon,
  claimStepEarn: ClaimStepEarnIcon,
  claimVerifiedBadge: ClaimVerifiedBadgeIcon,
  claimDotSeparator: ClaimDotSeparatorIcon,
  claimViewsEye: ClaimViewsEyeIcon,
  claimQuote: ClaimQuoteIcon,
  claimExternalLink: ClaimExternalLinkIcon,
  // Video controls
  cameraOnOutline: CameraOnOutlineIcon,
  cameraOffOutline: CameraOffOutlineIcon,
  microphoneOnOutline: MicrophoneOnOutlineIcon,
  microphoneOffOutline: MicrophoneOffOutlineIcon,
  // Menu icons
  bagIcon: Bag, // Products
  bellIcon: Bell, // Notifications
  cogIcon: Cog, // Settings
  microphoneIcon: Microphone, // Interviews
  playIcon: Play, // Media Feed
  priceTagIcon: PriceTag, // Brand Deals
  salesIcon: Sales, // Sales
  shirtIcon: Shirt, // Merch
  shoppingCartIcon: ShoppingCart, // Orders
  starIcon: Star, // Experiences
  statsIcon: Stats, // Dashboard
  streamsIcon: Streams, // Streams
  userCircleIcon: UserCircle, // Profile
};

export type IconNames = keyof typeof ICONS;

export type MillionsIconProps = React.ComponentPropsWithoutRef<'svg'> & {
  name: IconNames;
  className?: string;
  withoutFill?: boolean;
  size?: number;
};

const MillionsIcon = ({
  name,
  className,
  size = 24,
  ...rest
}: MillionsIconProps) => {
  const SvgTag = ICONS[name] as 'svg';

  return (
    <SvgTag
      width={size}
      height={size}
      className={cn(
        styles.root,
        {
          [styles.tipHand]: name === 'tipHand',
        },
        className
      )}
      data-icon-name={name}
      aria-hidden="true"
      role="presentation"
      focusable="false"
      {...rest}
    />
  );
};

export default MillionsIcon;
